
import './style.scss'
import DashboardSideMenu from '../../sections/dashboardSideMenu/DashboardSideMenu';
import DashboardHeader from '../../sections/dashboardHeader/DashboardHeader';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { userStateData } from '../../data/userStateData';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
import DashboardInstructorSideMenu from '../../sections/dashboardInstructorSideMenu/DashboardInstructorSideMenu';
import DashboardProfileContentArea from '../../sections/dashboardProfileContentArea/DashboardProfileContentArea';
import DashboardInstructorProfileContentArea from '../../sections/dashboardInstructorProfileContentArea/DashboardInstructorProfileContentArea';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { PAGE_URLS } from '../../constants/hrefLinks';

function DashboardProfile() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(setSubPage(DashboardSubPages.SETTINGS))
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == false) {
				window.location.replace(PAGE_URLS.SEARCH)
			} else {
				// Load user data such as interactions data
				loadProfileData()
			}
		}
	}, [loginChecked])

	const loadProfileData = () => {
		dispatch(setDataLoadRequestFinished(true))
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					{userStateData.isAnInstructor() ? <DashboardInstructorSideMenu /> : <DashboardSideMenu />}
					<div
						className='dashboard-content-wrap'
					>
						<DashboardHeader title='Dashboard - Profile' />
						{userStateData.isAnInstructor() ? <DashboardInstructorProfileContentArea /> : <DashboardProfileContentArea />}
					</div>
				</>
			}
		</div>
	)
}

export default DashboardProfile
